import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Alert, Spin } from 'antd';
import { GuideContent } from '../../../common';

function GuidePage(props) {
  const { tokenInfo } = props;
  const [loading, setLoading] = useState(false);
  const [guide, setGuide] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    const fetchGuide = async () => {
      if (!tokenInfo || !tokenInfo._id) return;
      setLoading(true);
      setError('');
      try {
        const res = await Axios.get(`/api/surveyGuide/resolve/${tokenInfo._id}`);
        if (!mounted) return;
        if (res.data && res.data.success) {
          setGuide(res.data.guide);
        } else {
          setError(
            (res.data && res.data.error) ||
              '回答案内の取得に失敗しました。'
          );
        }
      } catch (err) {
        if (!mounted) return;
        const message =
          err.response &&
          err.response.data &&
          (err.response.data.error || err.response.data.message);
        setError(message || '回答案内の取得に失敗しました。');
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchGuide();
    return () => {
      mounted = false;
    };
  }, [tokenInfo]);

  if (!tokenInfo) return null;

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '48px 0' }}>
        <Spin tip="回答案内を読み込み中..." />
      </div>
    );
  }

  if (error) {
    return (
      <Alert
        type="warning"
        showIcon
        message="回答案内を表示できません"
        description={error}
      />
    );
  }

  return <GuideContent content={guide && guide.content} />;
}

export default GuidePage;
